var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Result',_vm._b({scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.handleJumpRoute}},[_vm._v(" "+_vm._s(_vm.isLogin ? "返回首页" : "去登录")+" ")])]},proxy:true}])},'Result',_vm.err,false))
}
var staticRenderFns = []

export { render, staticRenderFns }